const getEnumLabel = (enums: EnumInfo[], value: number) => {
  if (!enums) {
    return '';
  }
  return enums.find((item) => item.selectValue === value)?.selectLabel || '';
};

export default getEnumLabel;
